const mutationTypes = {
  SET_DEFICIENCIES: 'SET_DEFICIENCIES',
  SET_EDITED_DEFICIENCY: 'SET_EDITED_DEFICIENCY',
  SET_DEFICIENCY: 'SET_DEFICIENCY',
  SET_LOADING: 'SET_LOADING',
}

const actionTypes = {
  FETCH_DEFICIENCIES: 'FETCH_DEFICIENCIES',
  CREATE_DEFICIENCY: 'CREATE_DEFICIENCY',
  DELETE_DEFICIENCY: 'DELETE_DEFICIENCY',
  UPDATE_DEFICIENCY: 'UPDATE_DEFICIENCY',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/DeficienciesTypes.js